import mergeWith from "lodash/mergeWith";

// custom merge function so that fields specified as 'undefined' are propagated in merge
// by default, lodash.merge ignores fields specified as undefined
// also handles arrays by replacing them instead of merging
// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-params
const merge = (object: any, other: any) => {
  // eslint-disable-next-line max-params
  return mergeWith(object, other, (objValue, srcValue, key, obj) => {
    // Handle undefined values
    if (objValue !== srcValue && srcValue === undefined) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = srcValue;
      return srcValue;
    }
    // Handle arrays - replace instead of merge
    // Returning srcValue tells mergeWith to use this value instead of merging
    if (Array.isArray(srcValue)) {
      return srcValue;
    }
  });
};

export { merge };
